(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const syncCardLabels = (section, rootEl) => {
    const addLabel = section.dataset.addToCartLabel;
    const soldLabel = section.dataset.soldOutLabel;
    if (!rootEl) return;

    if (addLabel) {
      rootEl.querySelectorAll('.custom-collection-card__button span:first-child').forEach((el) => {
        const parent = el.closest('button, a');
        if (parent && !parent.disabled) el.textContent = addLabel;
      });
    }

    if (soldLabel) {
      rootEl.querySelectorAll('.custom-collection-card__button[disabled]').forEach((el) => {
        el.textContent = soldLabel;
      });
    }
  };

  const applyVisibility = (section, list, footer) => {
    const showCount = Number(section.dataset.productsToShow) || 8;
    const enableMore = section.dataset.enableShowMore === 'true';
    const items = list ? Array.from(list.querySelectorAll('.product-grid__item')) : [];

    items.forEach((item, index) => {
      item.classList.toggle('is-hidden', enableMore && index >= showCount);
    });

    const hasHidden = items.some((item) => item.classList.contains('is-hidden'));
    if (!footer) return;

    if (enableMore && hasHidden) {
      footer.hidden = false;
      const button = footer.querySelector('[data-product-grid-more]');
      if (button) {
        button.dataset.batch = String(showCount);
        if (section.dataset.showMoreLabel) {
          button.textContent = section.dataset.showMoreLabel;
        }
      }
    } else {
      footer.remove();
    }
  };

  const setActiveFilter = (section, handle) => {
    section.querySelectorAll('[data-product-grid-filter]').forEach((button) => {
      const active = button.dataset.collectionHandle === handle;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const bindMore = (section) => {
    const button = section.querySelector('[data-product-grid-more]');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', () => {
      const batch = Number(button.dataset.batch) || Number(section.dataset.productsToShow) || 8;
      const list = section.querySelector('[data-product-grid-list]');
      const footer = section.querySelector('[data-product-grid-footer]');
      if (!list) return;

      const hiddenItems = list.querySelectorAll('.is-hidden');
      hiddenItems.forEach((item, index) => {
        if (index < batch) item.classList.remove('is-hidden');
      });

      if (list.querySelectorAll('.is-hidden').length === 0 && footer) {
        footer.remove();
      }
    });
  };

  const initGrid = (section) => {
    if (!section || section.dataset.productGridBound === 'true') return;
    section.dataset.productGridBound = 'true';

    let currentHandle = section.dataset.collectionHandle || '';
    let currentSort = section.dataset.sort || 'created-descending';
    let loading = false;
    const results = section.querySelector('[data-product-grid-results]');

    const loadCollection = async (handle, sortBy) => {
      if (!handle || !results || loading) return;
      loading = true;
      section.classList.add('is-loading');

      const params = new URLSearchParams();
      params.set('view', 'ajax-grid');
      if (sortBy) params.set('sort_by', sortBy);

      try {
        const response = await fetch(`${root}collections/${handle}?${params.toString()}`);
        if (!response.ok) throw new Error('Failed to load collection');
        const html = await response.text();
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const incoming = temp.querySelector('[data-product-grid-ajax]');
        if (!incoming) throw new Error('Missing grid markup');

        const wholesaleOnly = section.dataset.wholesaleOnly === 'true';
        incoming.querySelectorAll('.product-grid__item').forEach((item) => {
          const isWholesale = item.dataset.wholesaleProduct === 'true';
          if (wholesaleOnly && !isWholesale) item.remove();
          if (!wholesaleOnly && isWholesale) item.remove();
        });

        results.innerHTML = incoming.innerHTML;
        currentHandle = handle;
        currentSort = sortBy || currentSort;
        section.dataset.collectionHandle = currentHandle;
        section.dataset.sort = currentSort;

        const list = results.querySelector('[data-product-grid-list]');
        const footer = results.querySelector('[data-product-grid-footer]');
        syncCardLabels(section, results);
        applyVisibility(section, list, footer);
        setActiveFilter(section, currentHandle);
        bindMore(section);
      } catch (error) {
        console.error(error);
      } finally {
        section.classList.remove('is-loading');
        loading = false;
      }
    };

    section.querySelectorAll('[data-product-grid-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const handle = button.dataset.collectionHandle;
        if (!handle || handle === currentHandle) return;
        loadCollection(handle, currentSort);
      });
    });

    const sortSelect = section.querySelector('[data-product-grid-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        currentSort = sortSelect.value;
        section.dataset.sort = currentSort;
        if (!currentHandle) return;
        loadCollection(currentHandle, currentSort);
      });
    }

    bindMore(section);
  };

  const bindAll = () => {
    document.querySelectorAll('[data-product-grid]').forEach(initGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector
      ? event.target.querySelector('[data-product-grid]')
      : null;
    if (section) {
      section.dataset.productGridBound = 'false';
      initGrid(section);
    } else {
      bindAll();
    }
  });
})();
